export const environment = {
  EnvName: "sandbox",
  production: false,
  Azure: {
    AUTH_ENDPOINT: "https://login.microsoftonline.com",
    TENANT_ID: "a7499e28-6a7f-48d9-8b14-d3e690989660",
    APP_CLIENT_ID: "2834ac78-2716-44a0-bf57-309d3d89b0eb",
    REDIRECT_URL: "https://stargate-dev.weyer.com/",
    PROD_SUB_IDS: [],
    DEV_SUB_IDS: [ { id: "75eb9b4d-5f7d-4eb3-9f7d-8ac01e6c9778", name: "Shared Services Sandbox" } ],
    FUNCTIONS_ENDPOINT: "https://isw2sbxappstargate01.azurewebsites.net/api"
  },
  AWS: {
    AUTH_ENDPOINT: "https://sso.weyer.com/aws",
    ACCOUNTS: {
      '973700593114': { name: "Shared Sandbox" }
    },
    FILTER_ON_TEAM_NAME: false,
    DEV_CREDS: null
  },
  appInsights : {
    connectionString: "InstrumentationKey=f67e7bc8-b84a-464c-a348-d7ddcfe20325;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=3e71aad7-3312-4090-8798-23cdd26613f0"
  }
};
  